import type { FaireProductEntity } from "../../entity_types/product";

export const p_krf7u6p8g3: FaireProductEntity = {
  token: "p_krf7u6p8g3",
  type: "product",
  name: "Frosted Wedding Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1f8e508de83f387974643099ea31a9321f87c278be1eee01788201650bd449d9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d7755c02eac77ebe23f8fc82f290ce3b6f86eb4cb02f9bfcbc41195cd7d5404.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:44.888Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
